<template>
    <div id="rotate-words">
        <div>人生没有假设<br />  <span>当下即是全部</span></div>
        <div>背不动了<br />  <span>就放下</span></div>
        <div>伤不起的<br />  <span>就看淡</span></div>
        <div>想不通的<br />  <span>不想了</span></div>
        <div>恨不过的<br />  <span>放下吧</span></div>
        <div>时光如梭<br />  <span>前面的路还要走</span></div>
        <div>人生<br />  <span>就是一个修炼的过程</span></div>
        <div>不要用内心的不平<br />  <span>作践了自己也伤害了岁月</span></div>
    </div>
</template>

<script>
    export default {
        name: "MyBlog"
    }
</script>

<style scoped>


    #rotate-words {
        background-color:#af441e;
        background-image:url("http://img.fang99.cc/road.jpg");
        background-size:100%;
        background-repeat:no-repeat;
        background-attachment:fixed;
        z-index: 999;
        text-align: center;
        width: 100%;
        height: 80px;
        margin:auto;
        padding:50px 0px;
        font-size:2.2em;
        text-transform:uppercase;
        color:white;
    }

    #rotate-words span {
        display:block;
        height:50px;
        font-size:.7em;
        text-transform:lowercase;
        opacity:.8;
    }

    #rotate-words div {

        position:absolute;
        width: 80%;
        opacity:0;
        overflow:hidden;
        text-align: center;
        line-height:1.2em;
        animation: rotate-word 32s linear infinite 0s;
        left: 0px;
        right: 0px;
        margin-left: auto;
        margin-right: auto;
    }

    @keyframes rotate-word {
        0% { opacity: 0;  transform: translateX(0);filter:blur(10px);transform:scale(1.2)}
        3% { opacity: 1;  transform: translateX(0);filter:blur(0px);transform:scale(.9)}
        12% { opacity: 1; transform: translateX(0);filter:blur(0px);transform:scale(1)}
        16% { opacity: 0; transform: translateX(0);filter:blur(10px);transform:scale(1.2)}
        80% { opacity: 0}
        100% { opacity: 0}
    }

    #rotate-words div:nth-child(2) { animation-delay: 4s}
    #rotate-words div:nth-child(3) { animation-delay: 8s}
    #rotate-words div:nth-child(4) { animation-delay: 12s}
    #rotate-words div:nth-child(5) { animation-delay: 16s}
    #rotate-words div:nth-child(6) { animation-delay: 20s}
    #rotate-words div:nth-child(7) { animation-delay: 24s}
    #rotate-words div:nth-child(8) { animation-delay: 28s}

    @keyframes author {
        0% { opacity: 0;  transform: translateY(100px);filter:blur(10px);transform: scaleY(2)}
        20% { opacity:0; transform: translateY(200px);filter:blur(10px); transform: scaleY(2)}
        30% { opacity:1; transform: translateY(0);filter:blur(0px);transform: scaleY(1)}
        90% { opacity:1; transform: translateY(0);filter:blur(0px);transform: scaleY(.9)}
        100% { opacity:0; transform: translateY(0);filter:blur(10px);transform: scale(2)}
    }
</style>



// WEBPACK FOOTER //
// src/components/common/MyBlog.vue